import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'dkPhoneNumber',
    standalone: false
})
  export class dkPhoneNumberPipe implements PipeTransform {
    transform(rawNum) {
        return rawNum.toString().replace(/\d{2}(?=.)/g, '$& ');
    }
}